import { render, staticRenderFns } from "./AddNewIntegrationLink.vue?vue&type=template&id=72712bdc&"
import script from "./AddNewIntegrationLink.vue?vue&type=script&lang=js&"
export * from "./AddNewIntegrationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports